import Splide from '@splidejs/splide';
import '@splidejs/splide/css';
import { screens } from '../../../../config/breakpoints';

const phoneWidth = screens.phone_only.max.replace(/[^\d.-]/g, '');

const initSplide = () => {
  if (window.innerWidth < phoneWidth) {
    const splideContainer = document.querySelector('.stage .splide');
    if (splideContainer) {
      const options = {
        pagination: false,
        arrows: false,
        fixedWidth: '65%',
        mediaQuery: 'min',
        padding: { left: 16, right: 16 },
        breakpoints: {
          [phoneWidth]: {
            destroy: 'completely',
          },
        },
      };
      const splide = new Splide(splideContainer, options);
      splide.mount();
    }
  }
};

const mql = window.matchMedia(`(max-width: ${phoneWidth}px)`);

mql.onchange = e => {
  if (e.matches) {
    /* the viewport is phoneWidth or less */
    initSplide();
  }
};

document.addEventListener('DOMContentLoaded', initSplide);
